export const FACILITIES_SORTING_OPTION = {
  // DO NOT CHANGE. Values correspond to the imported facility's data structure (with - as way to go inside property).
  DEFAULT: null,
  COUNTRY: "address-country",
  CITY: "address-city",
  STORE_CODE: "storeCode"
};
